import type { FaireProductEntity } from "../../entity_types/product";

export const p_eryphrnxqg: FaireProductEntity = {
  token: "p_eryphrnxqg",
  type: "product",
  name: "Sweet Knitted Floral Colorful Strawberry Knotted Headband",
  brandToken: "b_m9g7q2h2bj",
  brandName: "MKS America",
  imageUrl:
    "https://cdn.faire.com/fastly/f777c51ee137bc2cad3eca265ed69d1ba7b5246fcbc24fda733ead2ec8aee94d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/170afedc4df56048eb2f4866889eb8156d1a46409bc848654259ccfdfa4ba0b0.jpeg",
    "https://cdn.faire.com/fastly/7a2a259ef301cc581fbcf8547bd6039831a23782ddb0e3cbd5d475ee2e133630.jpeg",
    "https://cdn.faire.com/fastly/9de225f4d28522602e1f2ae224b8e58dd16db6641b9a9a7c2aa56e8bcfee9fd8.jpeg",
    "https://cdn.faire.com/fastly/b15ef3d752087b7405964f538267cea1a79df7c9a1acf99be702c7b5a92c66db.jpeg",
    "https://cdn.faire.com/fastly/92ebcb445e64b92aa93d94c3eea5a40ce075d549d5c28b7e9e9538c24882a3ab.jpeg",
    "https://cdn.faire.com/fastly/defb23af4eeae0b219eb77bb65fe68c4478679619cd8894ad9f40a3cd1f6674f.jpeg",
    "https://cdn.faire.com/fastly/cdcd9cc04bcd66567fb6443ca399b5723d84244f9c89082d1c1eb71d31d3187f.jpeg",
    "https://cdn.faire.com/fastly/d2c373cb4497485ea3484567e666e03495fd8141947890a3f638aca1caf7bb88.jpeg",
    "https://cdn.faire.com/fastly/884795a5e15874feff2dde384eaf02c7d2b57696d95eadd8e24784bb222abe55.jpeg",
    "https://cdn.faire.com/fastly/44e48f1aa4052227fa949b4505c280cdd80b12295760709cf880d430c34d6c23.jpeg",
  ],
  priceDollars: 3.66,
  description:
    "Sweet Knitted Floral Colorful Strawberry Knotted Headband_MDQ02305\n\nBow Hair Claw Clip, Crochet Headband, Ribbon Hair Clip,Charm Jewelry Embellished Headband,Beaded Headband,Stainless Stee,Cuff Bracelet,Link Bracelet,Bangle Bracelet,tassel drop earrings,Frame sunglasses,Ladies Sunglasses,Drawstring bag, Belt bag,Socks for women,Mesh Gloves,Titanium steel Necklace",
  tags: [],
  msrpDollars: 7.32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:46.567Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
